// pages/TravelExpense/travelStatus.js
//
// Go-live parity (2026-09-24): audit 09-travel #27 — legacy shows all 8
// ExpenseStatus codes (TE\ExpenseApproval.cs, dbo.ExpenseStatus). The API
// now returns statusLabel from that table; these are only the fallbacks
// when the label is missing, so void / closed trips no longer show as
// "Status 8" / "Status 7".

import React from "react";
import { Badge } from "reactstrap";

export const STATUS_FALLBACK = {
    1: ["Draft", "secondary"],
    2: ["Submitted", "warning"],
    3: ["Approved", "success"],
    4: ["Denied", "danger"],
    5: ["In Progress", "info"],
    6: ["In Progress", "info"],
    7: ["Closed", "dark"],
    8: ["Void", "dark"],
};

export const statusText = (status, label) =>
    (label && String(label).trim()) || (STATUS_FALLBACK[status] ? STATUS_FALLBACK[status][0] : `Status ${status}`);

export const TravelStatusBadge = ({ status, label, style }) => {
    const color = STATUS_FALLBACK[status] ? STATUS_FALLBACK[status][1] : "info";
    return <Badge color={color} pill style={style}>{statusText(status, label)}</Badge>;
};

// Legacy cboNatureOfVisit choices (TravelExpenseApproval.Designer.vb).
export const NATURE_OF_VISIT = ["Sales", "Training", "Diagnostic", "Marketing", "Other"];

// ExpenseApprovalLog.Comment is nvarchar(255).
export const MAX_COMMENT = 255;

export default TravelStatusBadge;
